import $ from "jquery";

function initRadioBtns() {
  $(".btn-holder").each(function () {
    $(this).off("click");
    // set initial checked state
    const $btn = $(this);
    const isActive = $btn.hasClass("active");
    $btn.find(".checkbox").prop("checked", isActive);
    $(this).click(() => {
      const $btn = $(this);
      const isActive = !$btn.hasClass("active");

      // Toggle active class for the button circle and checkbox
      $btn.find(".btn-circle").toggleClass("active", isActive);
      $btn.toggleClass("active", isActive);
      $btn.find(".checkbox").prop("checked", isActive);
    });
  });
}

initRadioBtns();
